export class RemoteSlotApi {
    constructor({ baseURL, fetchImpl } = {}) {
        if (!baseURL) {
            throw new Error("RemoteSlotApi requires baseURL");
        }

        const request = fetchImpl ?? globalThis.fetch?.bind(globalThis);
        if (!request) {
            throw new Error("RemoteSlotApi requires fetch");
        }

        this._baseURL = baseURL.replace(/\/+$/, "");
        this._fetch = request;
    }

    async spin(params) {
        return this._get("/slot/spin", params);
    }

    async _get(path, params = {}) {
        const endpoint = path.startsWith("/") ? path : `/${path}`;
        const url = new URL(`${this._baseURL}${endpoint}`);

        for (const [key, value] of Object.entries(params)) {
            if (value !== undefined && value !== null) {
                url.searchParams.set(key, value);
            }
        }

        const response = await this._fetch(url.toString());
        if (!response.ok) {
            throw new Error(`Request failed: ${response.status}`);
        }

        return response.json();
    }
}
